module.exports = __webpack_public_path__ + "img/home.3107fe14.svg";